import { brand } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';
import { MarketCountryCode } from '@axo/shared/types';

export interface BrandListResponse {
  Items: brand.Brand[];
}

export function getBrands({ url: { service: baseURL }, token }: IAPI) {
  return async ({ marketCountry }: { marketCountry: MarketCountryCode }) =>
    send<never, BrandListResponse>({
      baseURL,
      token,
      path: `/brand?country=${encodeURIComponent(marketCountry)}&active=true`,
      method: 'GET',
    });
}

export function getBrand({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    brandName,
    marketCountry,
  }: {
    brandName: string;
    marketCountry: MarketCountryCode;
  }) =>
    send<never, brand.Brand>({
      baseURL,
      token,
      path: `/brand/${encodeURIComponent(brandName)}/country/${marketCountry}`,
      method: 'GET',
    });
}
